// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"264":"3691bcb7","363":"47cb1665","595":"81df6611","751":"41ad8038","789":"e15da862"}[chunkId] + ".css";
};